import React from 'react'
import tw from 'tailwind-styled-components'
import {FilenameUtil, Util} from 'yougile-util'
import {IconButton} from '@components/common/base/buttons'
import {ChatMessageFile} from '@components/common/base/chat-message'
import {Icon} from '@components/common/base/icon'

const TwAttachments = tw.div`
  flex-none
  flex
  flex-wrap
  gap-4
`

const TwFile = tw.div`
  w-fit
  p-4
  rounded-8
  shadow-border-1
  shadow-grey-l60
  bg-grey-l100
  flex
  gap-4
  select-none
`

const TwIcon = tw(Icon)`
`

const TwName = tw.span`
  text-secondary
  text-11
  leading-4
  font-semibold
  whitespace-nowrap
`

const TwSize = tw.span`
  text-placeholder
  text-11
  leading-4
  font-semibold
  uppercase
  whitespace-nowrap
  before:content-['(']
  after:content-[')']
`

const TwRemove = tw(IconButton)`
`

interface Props {
  files: File[]
  messageFiles?: ChatMessageFile[]
  onRemove: (i: number) => void
  onRemoveMessageFile?: (i: number) => void
  className?: string
}

export const Attachments = ({
  files,
  messageFiles = [],
  onRemove,
  onRemoveMessageFile,
  className
}: Props) => {
  const hasFiles = files.length > 0 || messageFiles.length > 0

  return hasFiles ? (
    <TwAttachments className={className}>
      {messageFiles.map((file, i) => (
        <TwFile key={`msg-${i}-${file.fileName}`}>
          <TwIcon icon="IconFile" size={16} color="secondary" />
          <TwName>{FilenameUtil.truncateFileName(file.fileName)}</TwName>
          <TwRemove
            icon="IconX"
            size="small"
            color="grey"
            onClick={() => onRemoveMessageFile?.(i)}
          />
        </TwFile>
      ))}

      {files.map((x, i) => (
        <TwFile key={i + '-' + x.name}>
          <TwIcon icon="IconFile" size={16} color="secondary" />
          <TwName>{FilenameUtil.truncateFileName(x.name)}</TwName>
          <TwSize>{Util.humanReadableSize(x.size)}</TwSize>
          <TwRemove
            icon="IconX"
            size="small"
            color="grey"
            onClick={() => onRemove(i)}
          />
        </TwFile>
      ))}
    </TwAttachments>
  ) : null
}
